<template>
  <div class="coverage-page">
    <div class="container">

      <div class="cov-eyebrow"><i class="fa fa-globe"></i> {{ cov_eyebrow }}</div>
      <h1 class="cov-title">{{ cov_title.replace('{count}', countryCount) }}</h1>
      <p class="cov-desc">{{ cov_desc }}</p>

      <div v-if="loading" class="cov-loading"><spinner></spinner></div>

      <template v-else>
        <div class="cov-grid">
          <div v-for="j in jurisdictions" :key="j.record_number" class="cov-chip">{{ j.country_name }}</div>
        </div>

        <div class="cov-stats">
          <div v-for="s in stats" :key="s.label" class="cov-stat">
            <div class="cov-stat__value">{{ s.value }}</div>
            <div class="cov-stat__label">{{ s.label }}</div>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import { cmsCoverage } from '@/services/cms';

export default {
  metaInfo() { return { title: "Coverage — 120+ jurisdictions | SherlockIT" }; },
  components: { Spinner },
  data() {
    return {
      loading: true,
      jurisdictions: [],
      rawStats: [],
      cov_eyebrow: "Direct registry connectivity",
      cov_title:   "Coverage across {count}+ jurisdictions",
      cov_desc:    "Every record is fetched live from the official source registry, with timestamped chain of custody. Below is a sample of supported jurisdictions.",
    };
  },
  computed: {
    countryCount() {
      const s = this.rawStats.find(s => Object.keys(s)[0] === "Countries");
      return s ? Object.values(s)[0] : this.jurisdictions.length;
    },
    stats() {
      const companies = this.rawStats.find(s => Object.keys(s)[0] === "Companies");
      return [
        { value: this.countryCount + "+", label: "Jurisdictions" },
        { value: companies ? Object.values(companies)[0] : "55M+", label: "Companies indexed" },
        { value: "Real-time", label: "Refresh on demand" },
      ];
    },
  },
  async mounted() {
    const applyCoverage = (cms) => {
      if (cms.page_eyebrow) this.cov_eyebrow = cms.page_eyebrow;
      if (cms.page_title)   this.cov_title   = cms.page_title;
      if (cms.page_desc)    this.cov_desc    = cms.page_desc;
    };
    const [cms] = await Promise.all([
      cmsCoverage(this.$data, applyCoverage.bind(this)),
      Promise.all([
        this.$axios.get("search/country-list/"),
        this.$axios.get("search/web-stats/"),
      ]).then(([cRes, sRes]) => {
        this.jurisdictions = cRes.data.sort((a, b) => a.country_name.localeCompare(b.country_name));
        this.rawStats = sRes.data;
        this.loading = false;
      }).catch(() => { this.loading = false; }),
    ]);
    applyCoverage(cms);
  },
};
</script>

<style scoped>
.coverage-page { background: oklch(0.985 0.004 240); padding: 40px 0 80px; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }

.cov-eyebrow { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; color: #64748b; margin-bottom: 8px; }
.cov-eyebrow .fa { color: #575ECF; }
.cov-title { font-size: clamp(1.75rem, 3.5vw, 2.5rem); font-weight: 600; letter-spacing: -0.02em; color: #0a1428; margin-bottom: 12px; }
.cov-desc { font-size: 1rem; color: #64748b; max-width: 600px; line-height: 1.7; margin-bottom: 32px; }

.cov-loading { text-align: center; padding: 60px 0; }

.cov-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 40px; }
.cov-chip { border: 1px solid #e2e8f0; border-radius: 8px; background: #fff; padding: 8px 12px; font-size: 14px; color: #0a1428; }

.cov-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.cov-stat { border: 1px solid #e2e8f0; border-radius: 16px; background: #fff; padding: 24px; }
.cov-stat__value { font-size: 2rem; font-weight: 600; color: #575ECF; letter-spacing: -0.02em; margin-bottom: 4px; }
.cov-stat__label { font-size: 14px; color: #64748b; }

@media (max-width: 768px) { .cov-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 560px) { .cov-grid { grid-template-columns: repeat(2, 1fr); } .cov-stats { grid-template-columns: 1fr; } }
</style>
